import { Box, Divider } from "@mui/material";
import MyEmployeePayroleReports from "../Reports/MyEmployeePayroleReports";
import MyEmployeePayroleReportsNotProcessed from "../Reports/MyEmployeePayroleReportsNotProcessed";

const RegularEmployees = ({
  selectedYear,
  selectedMonth,
  currentMonthData,
  userRole,
  paydate,
  worklocationData,
  handleWorkLoacation,
}) => {
  const readOnly = () => {
    if (userRole === "both") {
      if (currentMonthData?.["Regular_status"] === "Action Needed") {
        return true;
      } else {
        return false;
      }
    } else if (userRole === "approver") {
      return true;
    } else if (userRole === "admin") {
      return currentMonthData?.["Regular_status"] === "Action Needed";
    }
  };
  return (
    <Box>
      <MyEmployeePayroleReports
        selectedYear={selectedYear}
        selectedMonth={selectedMonth}
        currentMonthData={currentMonthData}
        readOnly={readOnly()}
        userRole={userRole}
        paydate={paydate}
        worklocationData={worklocationData}
        handleWorkLoacation={handleWorkLoacation}
      />
      <Divider sx={{ my: 3 }} />
      <MyEmployeePayroleReportsNotProcessed
        selectedYear={selectedYear}
        selectedMonth={selectedMonth}
        currentMonthData={currentMonthData}
        readOnly={readOnly()}
        paydate={paydate}
        worklocationData={worklocationData}
        handleWorkLoacation={handleWorkLoacation}
      />
    </Box>
  );
};

export default RegularEmployees;
